import { render, staticRenderFns } from "./meituan.vue?vue&type=template&id=b228dbe8&"
import script from "./meituan.vue?vue&type=script&lang=js&"
export * from "./meituan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports